import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import AutoScroll from 'embla-carousel-auto-scroll';

const images = [
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/6puwovcr_1.jpg',
    alt: 'Villa mit Pool - A-Frame Design'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/f3wfw5k6_2.jpg',
    alt: 'Steg zum Wasser mit grünem Boot'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/h1hq06eo_3.jpg',
    alt: 'Pool mit Palmen und Seeblick'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/cjdi3uhn_4.jpg',
    alt: 'Welcome-Dekoration'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/t742rsqn_5.jpg',
    alt: 'Buddha und Thai-Dekoration'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/qzp1yh2l_6.jpg',
    alt: 'Villa Innenansicht mit Treppe'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/ov3qi372_7.jpg',
    alt: 'Schlafzimmer mit Klimaanlage'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/g7af5q97_8.jpg',
    alt: 'Wohnzimmer von oben mit Bar'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/hv69clbh_9.jpg',
    alt: 'Schlafzimmer mit A-Frame Fenster'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/r8bukx5e_10.jpg',
    alt: 'Ausblick auf Pool und See bei Sonnenuntergang'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/uojc3bpw_11.jpg',
    alt: 'Villa bei Nacht mit Pool-Beleuchtung'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/3jj3b2b6_12.jpg',
    alt: 'Villa Außenansicht mit Palmen'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/dgllsioj_13.jpg',
    alt: 'Palmen bei Sonnenuntergang'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/ljw9r1yy_14.jpg',
    alt: 'Villa Thailand Gästebuch'
  },
  {
    url: 'https://customer-assets.emergentagent.com/job_html-server-setup/artifacts/ee1z09gw_15.jpg',
    alt: 'Pool-Detailansicht'
  }
];

const ImageCarousel = () => {
  const [emblaRef] = useEmblaCarousel(
    { 
      loop: true,
      dragFree: false,
      draggable: false,
      align: 'start'
    },
    [
      AutoScroll({
        playOnInit: true,
        speed: 1,
        stopOnInteraction: false,
        stopOnMouseEnter: false,
        direction: 'forward'
      })
    ]
  );

  return (
    <div className="relative group pointer-events-none select-none">
      <div className="overflow-hidden rounded-2xl" ref={emblaRef}>
        <div className="flex gap-4">
          {images.map((image, index) => (
            <div
              key={index}
              className="flex-[0_0_90%] sm:flex-[0_0_60%] md:flex-[0_0_45%] lg:flex-[0_0_32%] min-w-0"
            >
              <div className="relative aspect-[4/3] overflow-hidden rounded-xl shadow-lg">
                <img
                  src={image.url}
                  alt={image.alt}
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                  draggable="false"
                />
              </div>
            </div>
          ))}
          {/* Spacer zwischen letztem und erstem Bild */}
          <div className="w-2 flex-shrink-0"></div>
        </div>
      </div>
    </div>
  );
};

export default ImageCarousel;